import { Component, OnInit } from '@angular/core';
import { pricingData } from '../../pages/utility/pricing/data';
import { Pricing } from '../../pages/utility/pricing/pricing.model';

@Component({
  selector: 'app-planes',
  templateUrl: './planes.component.html',
  styleUrls: ['./planes.component.scss']
})
export class PlanesComponent implements OnInit {
  pricingData: Pricing[];
  constructor() { }

  ngOnInit(): void {
    this.pricingData = pricingData;
  }

}
